import { ReactNode } from 'react';

import { Flex, Heading } from '@chakra-ui/react';

import { Glyph } from '~/components/glyph';

type SectionHeadingProps = {
  colorScheme: 'blue' | 'purple';
  glyphName?: string;
  pictogram?: ReactNode;
  singleLineOnMobile?: boolean;
  title: string;
};

export function SectionHeading({
  colorScheme,
  glyphName,
  pictogram,
  singleLineOnMobile = false,
  title,
}: SectionHeadingProps) {
  return (
    <Flex
      alignItems='center'
      borderBottom='1px solid'
      borderColor={`${colorScheme}.300`}
      gap={{ base: 3, md: 5 }}
      paddingBottom={4}
    >
      {pictogram ?? (glyphName ? <Glyph height={48} name={glyphName} width={48} /> : null)}
      <Heading
        as='h2'
        color={`${colorScheme}.500`}
        size={{ base: 'v2-h6', md: 'heading-6' }}
        whiteSpace={singleLineOnMobile ? { base: 'nowrap', md: 'normal' } : 'normal'}
      >
        {title}
      </Heading>
    </Flex>
  );
}
